/** Москва — город вылета по умолчанию. */
export const DEFAULT_DEPARTURE_CITY_ID = 2;
